/* eslint-disable typescript-sort-keys/string-enum */

enum ApiRoutePath {
  // Edit mortgage
  LIST_MORTGAGE_LOAN_ACCOUNTS = '/bank/loans/afterloan/selfservice/v1/loan-accounts',
  LIST_PAYMENT_ACCOUNTS = '/bank/loans/afterloan/selfservice/v1/payment-accounts',
  POST_CHANGE_TO_INTEREST_ONLY = '/bank/loans/afterloan/selfservice/v1/change-to-interest-only',
  POST_CHANGE_REPAYMENT_PERIOD = '/bank/loans/afterloan/selfservice/v1/change-repayment-period',
  POST_CHANGE_PAYMENT_DATE = '/bank/loans/afterloan/selfservice/v1/change-payment-date',
  POST_CHANGE_PAYMENT_ACCOUNT = '/bank/loans/afterloan/selfservice/v1/change-payment-account',
  POST_CHANGE_PAYMENT_AMOUNT = '/bank/loans/afterloan/selfservice/v1/change-payment-amount',
  POST_CALCULATE_LOAN_DOWNPAYMENT = '/open/bank/loans/products/installment',
  GET_CURRENT_INTEREST_RATE = 'open/bank/loans/products/current-interest-rate',

  // Online Bank
  GET_BANK_ACCOUNTS_FOR_SHARED_ACCOUNT = 'bank/selfservice/v1/bank-accounts-for-shared-accounts',
  GET_CUSTOMER_BANK_ACCOUNTS = '/bank/accounts',
  GET_BANK_ACCOUNTS = 'bank/selfservice/v1/bank-accounts',
  GET_COUNTRIES = 'bank/loans/consumer-loans/countries',
  GET_FIXED_RATE_DEPOSIT_ACCOUNTS = '/bank/selfservice/v1/bank-accounts/fixed-rate-deposit',
  GET_HAS_ACCESS_TO_FOREIGN_PAYMENTS = '/bank/selfservice/v1/has-foreign-payments-access',
  POST_RENEW_FIXED_RATE_DEPOSIT_ACCOUNTS = '/bank/selfservice/v1/bank-accounts/renew-fixed-rate-deposit',
  POST_VALIDATE_BANK_ACCOUNT = 'bank/accounts/validate',
  POST_CLOSE_BANK_ACCOUNTS = 'bank/selfservice/v1/close-bank-accounts',
  POST_ACCESS_TO_FOREIGN_PAYMENTS = 'bank/selfservice/v1/access-to-foreign-payments',
  POST_SHARED_ACCPUNTS_WITH_CARD = 'bank/selfservice/v1/shared-accounts-with-card',
  POST_ORDER_PUM = 'bank/selfservice/v1/order-pum',
  POST_ORDER_ACCOUNT_STATEMENTS = '/bank/selfservice/v1/bank-accounts/order-account-statements',
  POST_ORDER_GOODNESS_CERTIFICATE_OR_CUSTOMER_DECLARTION = '/bank/selfservice/v1/order-goodness-certificate-or-customer-declaration',
  POST_ORDER_BANK_SWITCH = '/bank/selfservice/v1/bank-switch',
  POST_DOCUMENTS = '/shared/documents/file',
  GET_BSU_ACCOUNT = '/bank/selfservice/v1/bank-accounts/get-bank-account-for-terminate-BSU-account',
  POST_CLOSE_BSU_ACCOUNT = '/bank/selfservice/v1/terminate-BSU-account',

  // Online Bank for Children
  GET_CHILDREN = '/bank/selfservice/v1/children/',
  GET_PARENT_INFO = 'bank/loans/afterloan/person-info',
  POST_ORDER_CHILD_SERVICE = '/bank/selfservice/v2/children',

  // Credit Card
  GET_CUSTOMER_HAS_ONBOARDED = '/bank/customers/check/has-onboarded',
  GET_CREDIT_CARD = '/bank/selfservice/v1/credit-card',
  POST_APPLY_OR_MODIFY_FOR_CREDIT_CARD = '/bank/selfservice/v1/credit-card/apply-for-new-or-increase-credit-limit',
  POST_DECREASE_CREDIT_LIMIT = '/bank/selfservice/v1/credit-card/decrease-credit-limit',
  POST_TERMINATE_CREDIT_CARD = '/bank/selfservice/v1/credit-card/terminate-credit-card',

  // Common
  GET_CUSTOMER_CONTACT_INFO = '/bank/customers/contact-info',
}

export enum ChildServices {
  ORDER_BANK_ACCOUNT = 'bank-account',
  ORDER_BANK_ID = 'bank-id',
  ORDER_PUM = 'pum',
}

export default ApiRoutePath;
